module.exports = __webpack_public_path__ + "static/2-77dfa2f16e900e07c55fde9e34299099.jpg";